import React from 'react';
import { Box, Button, Typography } from '@mui/material';

/**
 * Generic authenticated 404 — used for hidden routes in the public edition.
 */
const AppRouteNotFound = () => (
    <Box
        sx={{
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            justifyContent: 'center',
            height: '100%',
            textAlign: 'center',
            p: 4,
        }}
        data-testid="app-route-not-found"
    >
        <img
            src="/synaptix-pulse-logo.svg"
            alt="synaptix Pulse"
            style={{ width: '80px', height: '80px', marginBottom: '20px' }}
        />
        <Typography variant="h4" gutterBottom>
            Page Not Found
        </Typography>
        <Typography variant="body1" color="text.secondary" gutterBottom>
            The page you&apos;re looking for doesn&apos;t exist.
        </Typography>
        <Typography variant="body2" color="text.secondary" sx={{ mb: 3 }}>
            synaptix Pulse - Professional Services Automation
        </Typography>
        <Button
            variant="contained"
            onClick={() => window.history.back()}
            sx={{ mt: 2 }}
        >
            Go Back
        </Button>
    </Box>
);

export default AppRouteNotFound;
